export class TestMethods {
  public static isRelay (iceCandidate: RTCIceCandidate): boolean {
    return iceCandidate.type === 'relay';
  }

  public static isReflexive (iceCandidate: RTCIceCandidate): boolean {
    return iceCandidate.type === 'srflx';
  }

  public static isHost (iceCandidate: RTCIceCandidate): boolean {
    return iceCandidate.type === 'host';
  }

  public static isUdp (iceCandidate: RTCIceCandidate): boolean {
    return iceCandidate.protocol === 'udp';
  }

  public static isTcp (iceCandidate: RTCIceCandidate): boolean {
    return iceCandidate.protocol === 'tcp';
  }

  public static isIpv6 (iceCandidate: RTCIceCandidate): boolean {
    const regex = /((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}/;
    return regex.test(iceCandidate.candidate);
  }
}
